import React from "react";
import content from "../content/content.json";

const Search = () => {
  const { searchPanel, shared } = content;

  return (
    <div className="absolute top-full h-screen left-0 w-full bg-white shadow-lg z-50 py-12">
      <div className="px-8 bg-gray-100 py-8">
        <p className="text-2xl font-semibold text-black mb-4">{searchPanel.prompt}</p>

        <div className="relative">
          <input
            type="text"
            placeholder={searchPanel.placeholder}
            className="w-full bg-transparent border-0 border-b-2 border-gray-300 text-back placeholder-gray-300 py-3 pr-12 pl-1 focus:outline-none transition duration-300 text-4xl font-bold"
          />
          <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
            <svg className="h-5 w-6 text-back" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35M16.65 16.65A7.5 7.5 0 1016.65 2a7.5 7.5 0 000 15z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 h-full">
        <div className="bg-gray-50 p-8 h-full">
          <h3 className="text-sm font-bold text-[#1C1F2B] mb-6">{searchPanel.popularHeading}</h3>
          <ul className="space-y-3 text-lg text-gray-700">
            {searchPanel.popular.map((term) => (
              <li key={term} className="hover:text-[#D00] cursor-pointer">
                {term}
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-gray-50 p-8 h-full">
          <h3 className="text-sm font-bold text-[#1C1F2B] mb-6">{searchPanel.topInsightsHeading}</h3>

          {searchPanel.topInsights.map((insight, index) => (
            <div key={insight.title} className={`flex items-center space-x-4 ${index === 0 ? "mb-6" : ""}`}>
              <img src={insight.image} alt={insight.imageAlt} className="w-32 h-20 object-cover rounded-md" />
              <div>
                <p className="text-sm text-gray-500">{insight.type}</p>
                <p className="text-lg text-gray-700 font-medium">{insight.title}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gray-50 p-8 h-full flex items-start">
          <a href="#" className="relative inline-flex items-center text-[#D00] font-semibold group">
            <span className="relative inline-block transition-all duration-300">
              {searchPanel.viewAllInsights}
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-[#D00] transition-all duration-300 ease-in-out group-hover:w-full"></span>
            </span>
            <span className="ml-2 text-lg transition-transform duration-300 group-hover:translate-x-1">
              {shared.arrow}
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Search;

